export default __webpack_public_path__ + "static/media/SD.77806bee.svg";